"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _system = require("@mui/system");
var _default = exports["default"] = (0, _system.styled)("div")({
  marginTop: 50,
  marginBottom: 50,
  width: "100%",
  height: 2,
  opacity: 0.8,
  backgroundColor: "#e6e7e8"
});